export default __webpack_public_path__ + "static/media/zenyatta-discord2.a9977a2b.mp3";